// extracted by mini-css-extract-plugin
export default {"mobileHotelWishlist":"wishlist-module__mobileHotelWishlist__HJuiz","checkoutWishlist":"wishlist-module__checkoutWishlist__ru0Mr"};